import LegalLayout from "./LegalLayout";

export default function LegalNoticePage() {
  return (
    <LegalLayout
      title="Mentions Légales"
      subtitle="Informations légales et coordonnées de l'éditeur"
      testId="legal-notice-page"
    >
      <h2>Éditeur du site</h2>
      <p>
        Le présent site <a href="https://afrimeet.org">afrimeet.org</a> et la plateforme AfriMeet
        sont édités par <strong>AfriMeet</strong>.
      </p>
      <ul>
        <li><strong>Dénomination commerciale</strong> : AfriMeet</li>
        <li><strong>Forme juridique</strong> : À compléter par l&apos;éditeur (SAS, SARL, SUARL, etc.)</li>
        <li><strong>Siège social</strong> : À compléter</li>
        <li><strong>Numéro RCCM / Registre du commerce</strong> : À compléter</li>
        <li><strong>Numéro fiscal (NIF / IFU)</strong> : À compléter</li>
        <li><strong>Directeur de la publication</strong> : À compléter</li>
        <li><strong>Contact</strong> : via la page <a href="/contact">Contact</a></li>
      </ul>

      <h2>Hébergement</h2>
      <p>
        Le site est hébergé sur l&apos;infrastructure cloud Emergent (Kubernetes managé) et utilise les
        services suivants :
      </p>
      <ul>
        <li><strong>MongoDB Atlas</strong> — base de données.</li>
        <li><strong>Stripe</strong> — paiements en ligne.</li>
        <li><strong>Resend</strong> — envoi d&apos;emails transactionnels.</li>
        <li><strong>OpenAI</strong> — transcription et résumé par IA.</li>
      </ul>

      <h2>Propriété intellectuelle</h2>
      <p>
        L&apos;ensemble des éléments présents sur ce site (textes, logos, graphismes, code source, modèles
        d&apos;IA fine-tunés) sont la propriété exclusive d&apos;AfriMeet, sauf mention contraire. Toute
        reproduction, représentation ou exploitation, totale ou partielle, sans autorisation écrite préalable
        est strictement interdite et constituerait une contrefaçon.
      </p>

      <h2>Marques</h2>
      <p>
        « AfriMeet » et le logo associé sont des marques. Les autres marques citées (Stripe, OpenAI, Resend,
        Wave, etc.) appartiennent à leurs propriétaires respectifs et sont mentionnées à titre informatif.
      </p>

      <h2>Liens hypertextes</h2>
      <p>
        Le site peut contenir des liens vers des sites tiers. AfriMeet ne saurait être tenu responsable du
        contenu ou des pratiques de ces sites externes.
      </p>

      <h2>Crédits</h2>
      <p>
        Design et développement : équipe AfriMeet. Polices : Inter, Playfair Display (Google Fonts).
        Icônes : Lucide.
      </p>

      <h2>Signalement de contenu illicite</h2>
      <p>
        Conformément à la législation applicable, tout contenu jugé illicite peut être signalé via la page
        <a href="/contact"> Contact</a>. AfriMeet s&apos;engage à examiner toute demande et à agir
        promptement en cas de manquement avéré.
      </p>
    </LegalLayout>
  );
}
